import { formatDataTest } from '@/common/dataTest/DataTest';
import { useInDialog } from '@/common/dialog/DialogScopeContext';

/*
* The methods in this class facilitate the wrapping of Cells with data-test-id for testing
*/

/*
* Default Cell Renderer
*/
export const DefaultWrappedRenderer = (params) => {
  const inDialog = useInDialog() ? 'dialog' : 'main';

  const value = params.value != null ? params.value.toString() : '';
  const displayName = params.colDef.displayName || params.colDef.colId;
  const rowIndex = params.node?.rowIndex;
  const level = params.node?.level;

  return (
    <div 
      data-test-grid-dialog={formatDataTest(inDialog)}
      data-test-grid-field={formatDataTest(displayName)}
      data-test-grid-row={formatDataTest(rowIndex)}
      data-test-grid-value={formatDataTest(value)}
      data-test-grid-level={formatDataTest(level)}
    >
      {value}
    </div>
  );
};

/*
* Wrapping Cell Renderer
*/
export const WrapCellRendererWithTestId = (Renderer) => {
  const inDialog = useInDialog() ? 'dialog' : 'main';

  return (params) => {
    const value = params.value != null ? params.value.toString() : '';
    const displayName = params.colDef?.displayName || params.colDef?.colId;
    const rowIndex = params.node?.rowIndex;
    const level = params.node?.level;

    return (
      <div 
        data-test-grid-dialog={formatDataTest(inDialog)}
        data-test-grid-field={formatDataTest(displayName)}
        data-test-grid-row={formatDataTest(rowIndex)}
        data-test-grid-value={formatDataTest(value)}
        data-test-grid-level={formatDataTest(level)}
      >
        <Renderer {...params} />
      </div>
    );
  };
};